var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_823_14172",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C24.8366 31 32 24.0604 32 15.5C32 6.93959 24.8366 0 16 0C7.16344 0 0 6.93959 0 15.5C0 24.0604 7.16344 31 16 31Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_823_14172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4762 -0.083313H-14.4922V31.0352H46.4762V-0.083313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4808 12.3689H19.6359V-0.0809326H12.3078V12.3689H-14.4663V18.5904H12.3078V31.0353H19.6359V18.5904H46.4808V12.3689Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.15482 -0.0844727L-7.34961 -0.0760858L9.89312 8.75601V-0.0844727H-7.15482Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97275 10.2729L-14.4917 -0.0828857V2.35806L1.09629 10.2729H5.97275Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0278 20.6763L46.4919 31.0321V28.5911L30.9043 20.6763H26.0278Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.15482 31.0859L-7.34961 31.0775L9.89312 22.2458V31.0859H-7.15482Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86837 20.6755L-14.478 31.0267L-9.71923 31.0313L9.91254 21.0963V20.6755H5.86837Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1558 -0.0861206L39.3506 -0.0777338L22.1079 8.75436V-0.0861206H39.1558Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4723 -0.0716403L41.8957 -0.0720215L22.125 9.9327V10.2838H26.3081L46.4723 -0.0716403Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1558 31.0831L39.3506 31.0748L22.1079 22.243V31.0831H39.1558Z",
    fill: "#00247D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag01);
export default __webpack_public_path__ + "static/media/Flag_01.c326847786d1bd7b4422a1fd7f3bfd80.svg";
export { ForwardRef as ReactComponent };